import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminReferrals() {
  const [list, setList] = useState({ items: [], total: 0 });
  const [board, setBoard] = useState([]);
  useEffect(() => { (async () => {
    try { setList((await api.get("/admin/referrals?page_size=100")).data); } catch {}
    try { setBoard((await api.get("/admin/referrals/leaderboard")).data || []); } catch {}
  })(); }, []);

  return (
    <div className="space-y-7" data-testid="admin-referrals-page">
      <header><h1 className="font-serif text-3xl text-ink tracking-tight">Referrals</h1><p className="text-ink-soft text-sm mt-1">{list.total} total</p></header>

      {/* Leaderboard */}
      <section className="border border-stone/40 bg-bone-dim p-5" data-testid="referrals-leaderboard">
        <div className="text-[10px] uppercase tracking-[0.22em] text-brass">Leaderboard — top 10 referrers</div>
        {board.length === 0 ? <p className="text-sm text-ink-soft mt-3">No credited referrals yet.</p> : (
          <ol className="mt-4 space-y-2">
            {board.map((r, i) => (
              <li key={r.referrer_user_id} className="grid grid-cols-12 gap-3 border-b border-stone/30 pb-2 items-baseline" data-testid={`board-row-${i}`}>
                <div className="col-span-1 font-serif text-2xl text-brass tabular-nums">{i + 1}</div>
                <div className="col-span-6 text-sm text-ink truncate font-mono">{r.referrer_email}</div>
                <div className="col-span-3 text-xs text-stone">credited</div>
                <div className="col-span-2 text-right font-serif text-xl text-ivy tabular-nums">{r.credited_count}</div>
              </li>
            ))}
          </ol>
        )}
      </section>

      {/* Table */}
      <div className="border border-stone/40 bg-bone overflow-x-auto" data-testid="referrals-table">
        <div className="grid grid-cols-12 gap-3 px-4 py-2.5 bg-bone-dim border-b border-stone/40 text-[10px] uppercase tracking-[0.18em] text-stone">
          <div className="col-span-2">Created</div>
          <div className="col-span-3">Referrer</div>
          <div className="col-span-3">Referee</div>
          <div className="col-span-1">Code</div>
          <div className="col-span-1">Discount</div>
          <div className="col-span-1">Credit</div>
          <div className="col-span-1">Status</div>
        </div>
        {list.items.length === 0 ? <div className="px-4 py-6 text-sm text-ink-soft">No referrals.</div> : list.items.map((r) => (
          <div key={r.referral_id} className="grid grid-cols-12 gap-3 px-4 py-3 border-b border-stone/20 items-baseline" data-testid={`ref-row-${r.referral_id}`}>
            <div className="col-span-2 text-[10px] text-stone font-mono tabular-nums">{(r.created_at || "").slice(0, 10)}</div>
            <div className="col-span-3 text-xs text-ink-soft truncate font-mono">{r.referrer_email}</div>
            <div className="col-span-3 text-xs text-ink-soft truncate font-mono">{r.referee_email}</div>
            <div className="col-span-1 text-[11px] font-mono text-ink">{r.code_used}</div>
            <div className="col-span-1 text-xs text-ink tabular-nums">${(Number(r.discount_applied_cents || 0) / 100).toFixed(0)}</div>
            <div className="col-span-1 text-xs text-ivy tabular-nums">${(Number(r.referrer_credit_cents || 0) / 100).toFixed(0)}</div>
            <div className="col-span-1 text-[10px] uppercase tracking-[0.18em]">
              <span className={r.status === "credited" ? "text-ivy" : "text-brass"}>{r.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
